import React from 'react';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './ButtonPreferredSources.scss';
import { IMAGE_URL } from '../../../constants';
import Link from 'components/Link';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const ButtonPreferredSources = (props) => {
  const { label } = props;

  const handleClick = () => {
    // GA Event tracking
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'preferred_source',
      label: label || 'N/A',
    });
  };

  return (
    <div className={s.buttonPreferredSources}>
      <Link 
        to="https://www.google.com/preferences/source?q=timesofindia.indiatimes" 
        target="_blank"
        onClick={handleClick}
      >
        <ImageV2 src={`${IMAGE_URL}123518384.cms`} alt="Prefrred On" />
      </Link>
    </div>
  );
};

ButtonPreferredSources.propTypes = {
  label: PropTypes.string,
};

ButtonPreferredSources.defaultProps = {
  label: 'N/A',
};

export default ButtonPreferredSources;
